<template>
  <dialog id="confirm_upload" class="modal">
    <div class="modal-box">
      <h3 class="mb-4 text-lg font-bold">Xác nhận tải lên</h3>

      <div class="py-2">
        <div class="font-medium">Tệp</div>
        <input class="input w-full text-base" v-model="file_name" />
      </div>

      <div class="py-2">
        <div class="font-medium">Kích thước</div>
        <div>
          {{ prettyBytes(props.file ? props.file.size : 0) }}
        </div>
      </div>

      <div class="py-2">
        <div class="font-medium">Đường dẫn tải lên</div>
        <div>{{ str_from_query("path") }}</div>
      </div>

      <div class="modal-action">
        <form method="dialog" class="flex gap-2">
          <button class="btn" value="cancel">Hủy</button>
          <!-- value "confirm" sẽ được gán cho dialog.returnValue khi đóng -->
          <button
            class="btn btn-primary"
            value="confirm"
            @click="handle_upload"
          >
            Xác nhận
          </button>
        </form>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import { str_from_query } from "@/api";
import prettyBytes from "pretty-bytes";
import { ref, watch } from "vue";
import { use_action } from "./useAction";
import { use_explorer } from "./useExplorer";

const props = defineProps<{
  file?: File;
}>();

const file_name = ref("");
const action_store = use_action();
const explorer_store = use_explorer();
watch(
  () => props.file,
  (new_f) => {
    file_name.value = new_f ? new_f.name : "";
  },
  { immediate: true },
);

const handle_upload = async () => {
  const action_id = await action_store.create_server_push_action(
    props.file,
    file_name.value,
  );
  if (!action_id) return;

  action_store.watch_for_action(action_id, {
    on_complete: async () => {
      const scan_id = await action_store.create_action({
        action: "scan",
        type: "explore",
        path: str_from_query("path"),
      });
      if (scan_id) action_store.watch_for_action(scan_id);
      explorer_store.get_files();
    },
  });
};
</script>
